import { CategoryBrowseNearbyCities } from './CategoryBrowseNearbyCities';

export default CategoryBrowseNearbyCities;
